import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';

export const getDocument = async (docId, collection) => firebase
    .firestore()
    .collection(collection)
    .doc(docId)
    .get()
    .then((doc) => (doc.exists ? doc.data() : null))
    .catch((err) => err);

export const getDocumentRef = (docId, collection) => firebase.firestore().collection(collection).doc(docId);

export const getUserId = async () => firebase.auth().currentUser.uid;

export const getCollection = (collectionName) => firebase.firestore().collection(collectionName);

export const getStorageRef = (fullPath) => {
  const storage = firebase.storage();
  const ref = storage.ref(fullPath);
  return ref;
};

export const updateField = (collection, docId, field, value) => firebase
    .firestore()
    .collection(collection)
    .doc(docId)
    .update({ [field]: value });
